<template lang="pug">
Page(titleType="custom")
  template(slot="header-left-dropdown")
    PageHeaderTabs(
      :links="pageTabLinks",
      translationGroup="B2B"
    )
  template(slot="content-center")

    TableLoading(v-if="isFetchingPageData")
    IntegrationTable(
      v-else,
      :fields="integrationFields",
      @onChange="updateItem"
      :data="Taxes"
      :isLoadingAction="isLoading"
    )
</template>

<script>
import IntegrationTable from '@/view/pages/Integration/components/Table'
import { vueWaitLoader } from '@/utils/baseOperations'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'B2BLOGOTax',

  components: {
    IntegrationTable
  },

  computed: {
    ...mapGetters('IntegrationB2bLogo', ['pageTabLinks']),
    ...mapGetters('Tax', ['Taxes']),

    isFetchingPageData () {
      return this.$wait.is('taxPageLoading')
    },

    isLoading () {
      return this.$wait.is('taxCodeUpdateB2B')
    },

    integrationFields () {
      return [
        {
          name: 'name',
          text: this.$t('Dictionary.Unit')
        },
        { name: 'code',
          isEditable: true,
          text: this.$t('Dictionary.AccountCode'),
          input: {
            validateRule: 'max:32|very_singularity:tax/check/code?id=,code',
            validateSingularityParams: 'id'
          }
        }
      ]
    }
  },

  /**
  **/

  methods: {
    ...mapActions('Tax', ['getTaxes']),
    ...mapActions('IntegrationB2bLogo', ['taxCodeUpdate']),
    ...mapActions('Notify', ['notifyShow']),

    updateItem: vueWaitLoader(async function (tax) {
      const payload = {
        id: tax.id,
        code: tax.code
      }
      const res = await this.taxCodeUpdate(payload)
      if (res) {
        const message = this.$t('Integration.StoreSuccessUpdated', { name: tax.name })
        this.notifyShow({ message })
      }
    }, 'taxCodeUpdateB2B')
  },

  async beforeMount () {
    this.$wait.start('taxPageLoading')
    await this.getTaxes()
    this.$wait.end('taxPageLoading')
  }
}
</script>
